import { AppBar, Box, Button, Avatar, Typography, IconButton, Tooltip } from '@mui/material'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import GetAppIcon from '@mui/icons-material/GetApp';
import React from 'react'
import { useNavigate } from 'react-router-dom'
import Farmer360logo from '../../assets/Farmer360logo.png';

function NavBar({ hideLogin }) {
  const navigate = useNavigate();
  const [deferredPrompt, setDeferredPrompt] = React.useState(null);
  const [installable, setInstallable] = React.useState(false);

  React.useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setInstallable(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setInstallable(false);
        setDeferredPrompt(null);
      }
    } else {
      // fallback: show instructions or do nothing
      alert('App installation is not available right now.');
    }
  };

  return (
    <AppBar
      sx={{
        backgroundColor: '#fff',
        padding: { xs: '0 1rem', md: '0.5rem 1.5rem' },
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img
          src={Farmer360logo}
          alt="Farmer360"
          style={{ height: 60, width: 150, objectFit: 'contain', cursor: 'pointer' }}
          onClick={() => {
            try {
              const userStr = localStorage.getItem('userDetails');
              const user = userStr ? JSON.parse(userStr) : null;
              console.log('User from localStorage:', user);
              if (!user || !user.role) {
                navigate('/');
                return;
              }
              const role = String(user.role).trim().toUpperCase();
              console.log('User role:', role);
              if (role === 'ADMIN' || role === 'AE' || role === 'ZM') {
                navigate('/masterData/dashboard');
              } else if (role === 'AM' || role === 'RM') {
                navigate('/amrm/farmerManagement');
              } else if (role === 'SO' || role === 'MDO') {
                navigate('/SOorMDO/dashboard');
              } else {
                navigate('/');
              }
            } catch (e) {
              console.error('Error parsing user from localStorage:', e);
              navigate('/');
            }
          }}
        />
        {!hideLogin && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, md: 0 } }}>
            {/* LOGIN button hidden on xs, visible on sm and up */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Button
                sx={{
                  color: '#fff',
                  background: 'linear-gradient(106.11deg, #4F46E5 0%, #3A349B 100%)',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '1rem',
                  width: 150,
                  borderRadius: 2,
                }}
                onClick={() => {
                  navigate('/login')
                }}
              >
                LOGIN
              </Button>
            </Box>
            {/* Install icon for PWA install, always visible */}
            <Tooltip title="Install App" arrow>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ml: 1.5 }}>
                <span>
                  <IconButton
                    color="primary"
                    onClick={handleInstallClick}
                    disabled={!installable}
                    sx={{ display: { xs: 'flex', md: 'flex' } }}
                    aria-label="Install App"
                  >
                    <GetAppIcon />
                  </IconButton>
                </span>
                <Typography variant="caption" sx={{ fontSize: 11, color: '#4318FF', mt: 0.2, lineHeight: 1 }}>
                  Install
                </Typography>
              </Box>
            </Tooltip>
            {/* Profile icon for xs screen only, styled as requested */}
            {(() => {
              const isProfileSelected = window.location.pathname.startsWith('/profile');
              return (
                <Box
                  key="Profile"
                  onClick={() => navigate('/profile')}
                  sx={{
                    display: { xs: 'flex', md: 'none' },
                    cursor: 'pointer',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: isProfileSelected ? '#4318FF' : 'rgba(0,0,0,0.35)',
                    ml: 1.5,
                  }}
                  aria-label="Profile"
                  role="button"
                >
                  <Avatar sx={{ bgcolor: '#4318FF', width: 28, height: 28 }}>
                    <AccountCircleIcon sx={{ width: 22, height: 22 }} />
                  </Avatar>
                  <Box
                    sx={{
                      mt: 0.5,
                      height: 3,
                      width: isProfileSelected ? 28 : 0,
                      bgcolor: '#4318FF',
                      borderRadius: 2,
                      transition: 'width 200ms ease',
                    }}
                  />
                </Box>
              );
            })()}
          </Box>
        )}
      </Box>
    </AppBar>
  )
}

export default NavBar